<template>
  <div class="settle-account-row">
    <div class="settle-account-table">
      <vxe-grid
        v-if="tableStatus"
        border
        show-footer
        :footer-method="footerMethod"
        show-overflow
        resizable
        ref="settleAccountsRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :edit-rules="tableRules"
        :edit-config="{ trigger: 'click', mode: 'cell', activeMethod: activeRowMethod }"
        :data="tableData"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        @edit-closed="closeEditTableHandler"
        height="300"
      >
        <template v-slot:buttons v-if="isCreate">
          <el-button @click="newRowHandler" size="small" type="primary" class="vxe-btn-primary"
            >新增
          </el-button>
          <el-button
            @click="deleteBtnClickHandler"
            size="small"
            type="danger"
            class="vxe-btn-delete"
            >删除
          </el-button>
          <el-button
            @click="importBtnClickHandler"
            size="small"
            type="primary"
            class="vxe-btn-delete"
            >导入明细
          </el-button>
        </template>
        <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
          :edit-render="item.editRender"
        >
          <template v-slot:edit="{ row }">
            <!-- 类别代码 -->
            <el-input
              :min="null"
              :controls="false"
              v-if="item.editRender.name == 'productCode'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input>
            <!-- 商品名称 -->
            <el-input
              :controls="false"
              v-if="item.editRender.name == 'productCategary'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input>
            <!-- 单位 -->
            <el-input
              :controls="false"
              v-if="item.editRender.name == 'unit'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input>
            <!-- 本期购进量 -->
            <el-input-number
              :precision="2"
              :min="-Infinity"
              :controls="false"
              v-if="item.editRender.name == 'purchaseQty'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 本期销售量 -->
            <el-input-number
              :precision="2"
              :min="-Infinity"
              :controls="false"
              v-if="item.editRender.name == 'saleQty'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 累计购进量 -->
            <el-input-number
              :precision="2"
              :min="-Infinity"
              :controls="false"
              v-if="item.editRender.name == 'purchaseQtySum'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 累计销售量 -->
            <el-input-number
              :precision="2"
              :min="-Infinity"
              :controls="false"
              v-if="item.editRender.name == 'saleQtySum'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 期初库存量 -->
            <el-input-number
              :precision="2"
              :min="-Infinity"
              :controls="false"
              v-if="item.editRender.name == 'inventoryQty'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 期末库存量 -->
            <el-input-number
              :precision="2"
              :min="-Infinity"
              :controls="false"
              v-if="item.editRender.name == 'inventoryQtyEnd'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 备注 -->
            <el-input
              v-if="item.editRender.name == 'remark'"
              v-model="row[item.field]"
              maxlength="50"
              @input="() => handleChange(row, item.field)"
            ></el-input>
            <!-- 附加 -->
            <!-- <el-checkbox v-if="item.editRender.name == 'additional'" v-model="row[item.field]" /> -->
          </template>
        </vxe-table-column>
      </vxe-grid>
      <!-- 分页 -->
      <IPagination
        :total="tableTotal"
        :multipleSelection="selectionList"
        @changePageHandler="changePageHandler"
      />
      <el-upload
        style="display: none"
        ref="siruiUpload"
        :data="importData"
        :action="uploadUrl"
        accept=".xls,.xlsx"
        :before-upload="uploadBefore"
        :on-success="uploadSuccess"
        :show-file-list="false"
        :with-credentials="true"
        :on-error="uploadError"
      >
        <el-button ref="importBtn"></el-button>
      </el-upload>
    </div>
  </div>
</template>

<script>
  import { tableColumnList, tableRules } from './index.js';
  import BASEAPI from '@/api/dataBase.js';
  import baseUrl from '@/common/config';
  import RECEIVABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  import MANAGEMENTSTATISTICS from '@/api/managementStatistics/statistics.js';

  export default {
    name: 'SettleAccountsRow',
    props: {
      baseFormData: {
        type: Object,
        require: true,
      },
      isCreate: {
        type: Boolean,
        require: true,
      },
      // 当前明细表
      currentDetailData: {
        type: Array,
        default: () => [],
      },
      // 详情的时候获取后端数据反填上去
      linesData: {
        type: Array,
        default: () => [],
      },
      settleAccountsDetailMap: {
        type: Map,
        default: () => new Map(),
      },
      // 商品
      productList: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        tableRules,
        tableColumnList,
        currencyList: [],
        uploadData: {}, // 上传参数
        uploadUrl: '',
        importData: {}, // 导入参数
        action: '',
        isFetchTableData: false,
        deleteLineIds: [], //删除行的ids
      };
    },
    computed: {
      basic_unit() {
        return this.dictListMap.basic_unit;
      },
      tableStatus() {
        return ['detail', 'edit', 'create'].includes(this.$route.query.status) &&
          this.$route.query?.id
          ? this.linesData.length
          : true;
      },
    },
    methods: {
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['purchaseQty'].includes(column.property)) {
              return this.$utils.commafy(
                this.$utils.toNumber(this.replaceZeroStr(this.sumNum(data, column.property))),
                { digits: 2 }
              );
            }
            if (['saleQty'].includes(column.property)) {
              return this.$utils.commafy(
                this.$utils.toNumber(this.replaceZeroStr(this.sumNum(data, column.property))),
                { digits: 2 }
              );
            }
            if (['inventoryQty'].includes(column.property)) {
              return this.$utils.commafy(
                this.$utils.toNumber(this.replaceZeroStr(this.sumNum(data, column.property))),
                { digits: 2 }
              );
            }

            if (['purchaseQtySum'].includes(column.property)) {
              return this.$utils.commafy(
                this.$utils.toNumber(this.replaceZeroStr(this.sumNum(data, column.property))),
                { digits: 2 }
              );
            }
            if (['saleQtySum'].includes(column.property)) {
              return this.$utils.commafy(
                this.$utils.toNumber(this.replaceZeroStr(this.sumNum(data, column.property))),
                { digits: 2 }
              );
            }
            if (['inventoryQtyEnd'].includes(column.property)) {
              return this.$utils.commafy(
                this.$utils.toNumber(this.replaceZeroStr(this.sumNum(data, column.property))),
                { digits: 2 }
              );
            }

            return null;
          }),
        ];
      },
      sumNum(list, field, numLength = 3) {
        let count = 0;
        list.forEach((item) => {
          count += +item[field];
        });
        return count > 0 ? count.toFixed(numLength) : 0;
      },
      async validAllEvent(isAdd = false) {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          isAdd ? this.$message.error('请完善结算行数据') : this.$message.error('请检查数据再提交');
          return true;
        } else {
          return false;
        }
      },
      //是否可以编辑
      activeRowMethod({ columnIndex, row }) {
        if (['create'].includes(this.$route.query?.status) && this.$route.query?.id) {
          if (row?.id) {
            if (columnIndex == 2 || columnIndex == 18 || columnIndex == 19) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        } else {
          return this.isCreate;
        }
      },
      changePageHandler(pageNum, pageSize) {
        console.log(pageNum, pageSize);
      },
      //选择合同移除所有行
      removeRowHandler() {
        let deleteIds = this.getTableData().map((item) => (item.id ? +item.id : null));
        deleteIds = deleteIds.filter((item) => item);
        this.deleteLineIds = this.deleteLineIds.concat(deleteIds);

        const $table = this.$refs.settleAccountsRef;
        $table.remove(this.getTableData()); //先删除表格所有数据
      },
      // 新增行
      async newRowHandler() {
        let checkLinesRefStatus = await this.validAllEvent(true);
        if (checkLinesRefStatus) {
          return;
        }
        // const { currencyCode, currencyName, exchangeRate, contractNo } = this.baseFormData;
        // if (!currencyCode || !currencyName || !exchangeRate) {
        //   this.$message.error('请补充表单数据');
        //   return;
        // }
        // 先获取表单中的币种和汇率
        // const rowData = { currencyCode, currencyName, exchangeRate, contractNo };
        const rowData = {};

        this.insertEvent(rowData, 0);
      },
      async insertEvent(rowData = {}, index = 0) {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, index);
          await $table.setActiveRow(newRow); // 设置当前行为活跃

          //默认选中
          this.selectActiveHandler(this.getTableData()[0]);
          await $table.validate(newRow).catch((errMap) => errMap);
        }
      },
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        this.$confirm('将同时删除结算明细，确认删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            const xIDList = this.selectionList.map((item) => item._XID);
            let deleteIds = this.selectionList.map((item) => (item.id ? +item.id : null));
            deleteIds = deleteIds.filter((item) => item);
            this.deleteLineIds = this.deleteLineIds.concat(deleteIds);
            this.tableData = this.getTableData().filter((item) => !xIDList.includes(item._XID));
            this.$emit('deleteTableHandler', xIDList, this.tableData);
            //删除选择行数组
            this.selectionList = [];
            this.$emit('selectionRowHandler', null);
          })
          .catch(() => {});
      },
      //下载模板
      async downLoadTemplate() {
        const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLE_TEMPLATE_API);
        if (data.code === 0) {
          window.open(data.data, '_blank');
        }
      },
      // 导入
      importBtnClickHandler() {
        if (
          this.baseFormData.companyCode === '' ||
          this.baseFormData.companyCode == null ||
          this.baseFormData.reportedBy === '' ||
          this.baseFormData.reportedBy == null ||
          this.baseFormData.dataMonth === '' ||
          this.baseFormData.dataMonth == null ||
          this.baseFormData.enterpriseName === '' ||
          this.baseFormData.enterpriseName == null
        ) {
          this.$message.error('导入Excel前，请先填写企业、录入人、年月');
          return;
        }
        this.$refs.importBtn.$el.click();
        this.setImport();
      },
      // 设置导入配置
      setImport() {
        // this.uploadUrl = baseUrl + '/' + RECEIVABLES_TRADE.IMPORT_SETTLE_ACCOUNT_API;
        this.uploadUrl =
          baseUrl +
          '/' +
          MANAGEMENTSTATISTICS.MANAGEMENTSTATISTICS_PRODUCTIONINFORMATIONNUMBER_IMPORTEXCEL;
        // const { contractNo } = this.baseFormData;
        this.importData = {
          access_token: this.userInfo.access_token,
          // selectContractStr: contractNo,
        };
      },
      async selectActiveHandler(row) {
        const $table = this.$refs.settleAccountsRef;
        await $table.setRadioRow(this.getTableData()[0]);
        console.log(row, '选择行变行');
        this.selectionList = [row];
        // 选择行
        this.$emit('selectionRowHandler', row);
      },

      handleSelectionChange({ selection }) {
        console.log(selection, '选择行');
        this.selectionList = selection;
      },

      handleChange(row, field) {
        console.log(row, field, '行');
        if (field === 'inventoryQty' || field === 'purchaseQtySum' || field === 'saleQtySum') {
          // 期末库存量=期初库存量+累计购进量-累计销售量
          row['inventoryQtyEnd'] = (
            row['inventoryQty'] +
            row['purchaseQtySum'] -
            row['saleQtySum']
          ).toFixed(2);
        }
      },
      async closeEditTableHandler() {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          // this.$message.error('请检查数据再提交');
        } else {
          // 派发事件

          const { currencyCode, currencyName, exchangeRate } = this.baseFormData;
          console.log(currencyCode, currencyName, exchangeRate, '查看修改费率');
          const tableData = this.getTableData().map((item) => {
            return {
              ...item,
              currencyCode,
              currencyName,
              exchangeRate,
            };
          });
          this.tableData = tableData;
          this.$emit('closeEditTableHandler', tableData);
          //默认选中
          await $table.setRadioRow(this.getTableData()[0]);
          this.selectActiveHandler(this.getTableData()[0]);
          await $table.clearActived();
          // //删除选择行数组
          // this.selectionList = [];
          // this.$emit('selectionRowHandler', null);
        }
      },
      // 获取币种
      async getCurrencyList() {
        const selectStatus = await this.$axios.get(BASEAPI.LIST_CURRENCY);
        if (selectStatus.data.code == 0) {
          this.currencyList = selectStatus.data.data.map((item) => {
            return {
              value: item.currencyCode,
              label: item.currencyName,
            };
          });
        }
      },
      getTableData() {
        const $table = this.$refs.settleAccountsRef;
        return $table.getTableData().fullData;
      },
      // 修改明细表中反填表格数据到表中
      fullTableData(val) {
        console.log(val, '修改明细反填');
        if (!val) return;
        console.log(this, '------>>');
        // const tableData = this.getTableData();
        // const {
        //   _XID,
        //   __deduction,
        //   propertyType,
        //   leasedArea,
        //   unleasedArea,
        //   selfUsedArea,
        //   revenue,
        //   rentPriceRange,
        //   remark,
        // } = val;

        // this.tableData.push(val);

        // this.tableData = this.tableData.concat(val);
        this.tableData = val;

        // if (__deduction) {
        //   console.log('11111');
        //   // 抵扣的时候，并且判重复
        //   const isExist = tableData.find((item) => item.__deduction == val.__deduction);
        //   if (!isExist) {
        //     this.tableData.push(val);
        //   }
        // } else {
        //   this.tableData = tableData.map((item) => {
        //     if (item._XID == _XID) {
        //       return {
        //         ...item,
        //         propertyType,
        //         leasedArea,
        //         unleasedArea,
        //         selfUsedArea,
        //         revenue,
        //         rentPriceRange,
        //         remark,
        //       };
        //     } else {
        //       return item;
        //     }
        //   });
        // }

        // 处理结算明细数据变动更新表单
        this.$emit('closeEditTableHandler', this.tableData);
      },
      // 开始上传
      uploadBefore() {
        this.loading.startLoading();
      },
      // 上传成功
      uploadSuccess(response) {
        this.loading.endLoading();
        if (response.code === 0) {
          if (response.data.length < 1) {
            this.$message.error('不支持的文件内容');
            return;
          }
          this.$message.success('导入成功');
          this.$emit('importData', response.data);
        } else {
          this.$message.error(`${response.msg}`);
        }
      },
      // 上传错误
      uploadError() {
        this.loading.endLoading();
        this.$message({
          showClose: true,
          message: this.$t('bank.message.importError'),
          type: 'error',
        });
      },
      // 反填远程返回的数据
      fullFetchTableData(val) {
        // 只需要处理一次,采用查重数组或者定义一个变量方式处理
        if (!this.isFetchTableData) {
          this.$nextTick(async () => {
            if (val.length > 0) {
              val.forEach((item) => {
                item.additional = item.additional == 1 ? true : false;
              });
            }
            const $table = this.$refs.settleAccountsRef;
            console.log(val, '查看');
            // for (let i = 0; i < val.length; i++) {
            //   $table?.insertAt(val[i], i);
            // }
            $table?.insertAt(val, 0);
            // this.tableData = val;
            this.isFetchTableData = true;
            // 处理反填的时候结算明细表
            this.$emit('closeEditTableHandler', this.getTableData(), true);
            //当第一个结算行有明细时默认显示
            if (val[0].lineDetails) {
              this.$emit('selectionRowHandler', this.getTableData()[0]);
              //默认选中
              await $table.setRadioRow(this.getTableData()[0]);
              this.selectActiveHandler(this.getTableData()[0]);
            }
          });
        }
      },
    },
    mounted() {
      this.getCurrencyList();

      // this.uploadUrl = baseUrl + '/' + RECEIVABLES_TRADE.IMPORT_SETTLE_ACCOUNT_API;
    },
    watch: {
      currentDetailData: {
        handler(val) {
          this.fullTableData(val);
        },
        // immediate: true,
        deep: true,
      },
      linesData: {
        handler(val) {
          if (val && Array.isArray(val) && val.length) {
            this.fullFetchTableData(val);
          }
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .settle-account-row {
    background: #fff;

    .settle-account-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
</style>
